<template>
  <div class="page-container clearfix">
    <side-nav :data="navConfig['zh-CN']" base="/component"></side-nav>
    <div class="page-content">
      <router-view></router-view>
    </div>
    <mobile></mobile>
  </div>
</template>

<script>
import 'highlight.js/styles/color-brewer.css';
import navConfig from './nav.config.json';

export default {
  data() {
    return {
      navConfig: navConfig
    };
  }
};
</script>

<style lang="css">
  @import './assets/docs.css';

  .page-container {
    height: 100%;
    overflow: scroll;

    h2 {
      font-size: 28px;
      color: #1f2d3d;
      margin: 20px 0;
      line-height: 40px;
    }

    h3 {
      font-size: 22px;
      margin: 23px 0;
    }

    h2, h3, h4, h5 {
      font-weight: normal;
      color: #1f2f3d;

      &:hover a {
        opacity: .4;
      }

      a {
        float: left;
        margin-left: -20px;
        opacity: 0;
        cursor: pointer;

        &:hover {
          opacity: .4;
        }
      }
    }

    p {
      font-size: 14px;
      color: #5e6d82;
      margin: 14px 0;
    }
  }

  .page-content {
    width: 52%;
    box-sizing: border-box;
    float: left;
    padding: 0 15px;
    overflow: auto;
    height: inherit;
  }

  .mobile-wrapper {
    float: left;
    width: 30%;
    height: 300px;
    position: relative;
  }

  .mobile {
    margin: 20px 20px 0;
    height: 100%;
    box-sizing: border-box;
    width: 365px;
  }

  .demo-page {
    width: 100%;
    border: 5px solid #f5f5f5;
    height: 580px;
  }

  .table {
    border-collapse: collapse;
    width: 100%;
    background-color: #fff;
    color: #5e6d82;
    font-size: 14px;
    margin-bottom: 45px;

    th {
      text-align: left;
      border-top: 1px solid #eaeefb;
      border-bottom: 1px solid #eaeefb;
      background-color: #eff2f7;
      padding: 10px;

      &:first-child {
        padding-left: 10px;
      }
    }

    td {
      border-bottom: 1px solid #eaeefb;
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// ExamplesDocsApp.vue?002448ff